import { formatAmount } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetBomDashboardStat } from "@/services";
import { Hotel, NotebookText, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useCommunityOverview = () => {
  const navigate = useNavigate();
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const [cards, setCards] = useState([
    {
      id: "1",
      icon: Hotel,
      count: 200,
      title: "Properties",
      className: "bg-amber-100",
      dataBorderColor: "border-amber-300",
      dataClassName: "bg-amber-200",
    },
    {
      id: "2",
      icon: User,
      count: 150,
      title: "Active Users",
      className: "bg-green-50",
      dataBorderColor: "border-green-300",
      dataClassName: "bg-green-200",
      data: [
        { count: 0, label: "Owners", apiKey: "ownerCount" },
        { count: 0, label: "Tenants", apiKey: "tenantCount" },
      ],
    },
    {
      id: "3",
      icon: NotebookText,
      count: 150,
      title: "Total Vendors",
      className: "bg-blue-50",
      dataBorderColor: "border-blue-300",
      dataClassName: "bg-blue-200",
      data: [
        { count: 0, label: "Active", apiKey: "totalActiveVendors" },
        { count: 0, label: "Inactive", apiKey: "totalInActiveVendors" },
      ],
    },
  ]);

  const { data: stat } = useGetBomDashboardStat({
    communityId: communityData?.communityId,
    queryParams: {
      enabled: !!communityData?.communityId,
    },
  });

  useEffect(() => {
    if (stat) {
      const firstSectionData = [...cards];

      const _firstSectionData = firstSectionData?.map((data: any) => {
        let total = 0;
        let _data = null;

        if (data?.id == "1") {
          _data = stat?.data?.modelStats?.map((val: any) => {
            total = total + val?.propertyCount || 0;
            return {
              ...val,
              label: val?.modelName?.toUpperCase(),
              count: val?.propertyCount,
            };
          });
        } else if (data?.apiKey) {
          total = stat?.data?.[data?.apiKey] || 0;
          _data = data?.data?.map((val: any) => {
            return {
              ...val,
              count: formatAmount(stat?.data?.[val?.apiKey] || "0"),
            };
          });
        } else {
          _data = data?.data?.map((val: any) => {
            total = total + stat?.data?.[val?.apiKey] || 0;
            return { ...val, count: stat?.data?.[val?.apiKey] || "0" };
          });
        }
        return {
          ...data,
          data: _data,
          count: total,
        };
      });

      setCards([..._firstSectionData]);
    }
  }, [stat]);
  
  const onCardClick = (link: any) => {
    link ? navigate(link) : "";
  }

  return {
    cards,
    onCardClick
  }
}

export default useCommunityOverview;